import apiClient from '../apiClient';
import { PUT_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const putTransportationUnitApi = (id, data) => {
  return apiClient.put(PUT_TRANSPORTATION_UNIT_URL(id), data);
};

export default putTransportationUnitApi;
